import React from 'react';
import './VibeCodeBanner.css';

const VibeCodeBanner: React.FC = () => {
  return (
    <div className="vibe-code-banner">
      <div className="vibe-code-content">
        <div className="vibe-code-text">
          <p className="vibe-code-title">
            Made with <span className="highlight">vibe coding</span>
          </p>
          <p className="vibe-code-subtitle" style={{ margin: 0 }}>
            Built with Figma, MCP, React, and Claude through a rigorous iterative process.
            Your feedback helps me understand what works and refine future iterations. I'd love to hear your thoughts!
          </p>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div className="token-counter" style={{ marginTop: 0 }}>
              <span className="token-count">30M+</span>
              <span className="token-label">tokens used</span>
            </div>
            <img
              src="/content/Animation Claude.gif"
              alt=""
              style={{ height: 80, width: 'auto', display: 'block', transform: 'translateY(-24px)' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VibeCodeBanner;
